import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { TempdetailService } from '/'
// import { TempdetailService } from "../temperature/temp.service";
// import { WaterService } from '../water/water.service'


@Injectable()
export class WaterdetailsService {
  myMainTest : any;

  constructor(private _http: HttpClient
    ) {


  }
      cardsData(id, apiToken: string) {
        let url = "https://api.cognition.world/v1/sustainability/water/external/details/cards"
        let dataToSend = {
          "deveui" : id
        }
      return this._http.post(url ,{dataToSend}, {headers:{'Authorization': apiToken}})
        .map(result => result);
  }

    leftChart(id, apiToken: string) {
      let url = " https://hbf6tf3lqa.execute-api.eu-west-1.amazonaws.com/dev/water/daygraph"
      let dataToSend = {
        "deveui" : id
      }
      return this._http.post(url ,{dataToSend}, {headers:{'Authorization': apiToken}})
        .map(result => result);
  }

    rightChart(id, apiToken: string) {
      return this._http.get("https://api.cognition.world/v1/demo/sustainability/water/external/details/hist/week/" + id, {headers:{'Authorization': apiToken}})
        .map(result => result);
  }

  waterDetailChart1X(id, tempDate3, apiToken: string) {
    ////console.log(tempDate3)
    return this._http.get("https://api.cognition.world/v1/sustainability/water/external/details/hist/" + id + "-" + tempDate3, {headers:{'Authorization': apiToken}})
      .map(result => result);
  }


  chartTempLoad(id, metricType,startDay,endDay, apiToken: string) {
    return this._http.get("https://api.cognition.world/v1/sustainability/water/external/details/hist/" + id +"-"+metricType+"-" + startDay + "-" + endDay, {headers:{'Authorization': apiToken}})
      .map(result => result);
  }


}



// WEBPACK FOOTER //
// ./src/app/dashboard/waterdetails/waterdetails.service.ts